import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { EtfPerformanceItem } from "../types";
import { loadEtfPerformance } from "../thunks/getEtfPerformanceThunk";

export const useDisplayEtfPerformance = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    EtfPerformanceItem | undefined
  >((store) => store.data.reports.securityStatistics.displayEtfPerformance);

  const displayedEtfPerformance =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadEtfPerformance( symbol));
    }
  }, [dispatch, symbol]);

  return displayedEtfPerformance;
};